import { Injectable } from '@angular/core';

import { environment } from '@env/environment';

@Injectable()
export class GenerateIconService {
  isCustomEmoji(url: string): boolean {
    const cleanUrl = url.replace(environment.MEDIA_API_URL, '');
    const index = cleanUrl.search(
      /(original\/)|(circle\/)|(disabled\/)|(pins\/)/gi,
    );
    return index < 0;
  }

  isCircle(url: string): boolean {
    const cleanUrl = url.replace(environment.MEDIA_API_URL, '');
    const index = cleanUrl.search(/circle\//gi);
    return index < 0;
  }

  changeIconType(url: string, type: string): string {
    if (url) {
      return url.replace('original', type);
    }
    return `${environment.MEDIA_API_URL_CIRCLE}1f3e0.png`;
  }

  changeTypeFromType(url: string, from: string, to: string): string {
    if (!url) {
      return '';
    }
    return url.replace(from, to);
  }

  changeIconTypeFromCircleToPins(url: string): string {
    return url.replace('circle', 'pins');
  }

  changeIconTypeFromCustomToCircle(url: string): string {
    return url ? url.replace(/(original)|(disabled)|(pins)/gi, 'circle') : '';
  }

  changeIconTypeFromCustomToPins(url: string): string {
    return url.replace(/(original)|(disabled)|(circle)/gi, 'pins');
  }
}
